import React, { useEffect, useState } from "react"
import { Card, CardBody, Modal, ModalBody } from "reactstrap"
import { useClientContext } from "../ClientContextBox"
import { axiosbaseurl } from "configure"
import LoadingButton from "components/Common/LoadingButton"
import useLocationData from "custom hooks/useLocationData"
import { customStyles } from "helpers/select-styles"
import Select from "react-select"
import { validateContact } from "helpers/common_helper"
import moment from "moment"

const Personal = ({ changeStep, client_id }) => {
  const {
    errors,
    setErrors,
    isReadOnly,
    clientId,
    setClientId,
    prefix_options,
    clientName,
    p_prefix,
    setPPrefix,
    p_forename,
    setPForename,
    p_surname,
    setPSurname,
    p_email,
    setPEmail,
    p_preferredName,
    setPPreferredName,
    p_dob,
    setPDob,
    p_occupation,
    setPOccupation,
    p_mobile,
    setPMobile,
    p_landline,
    setPLandline,
    p_address1,
    setPAddress1,
    p_address2,
    setPAddress2,
    p_city,
    setPCity,
    p_country,
    setPCountry,
    p_postcode,
    setPPostcode,
    p_contactDescription,
    setPContactDescription,
    isPrimaryAbsence,
    setisPrimaryAbsence,
    sameDetails,
    setSameDetails,
    s_prefix,
    setSPrefix,
    s_forename,
    setSForename,
    s_surname,
    setSSurname,
    s_email,
    setSEmail,
    s_preferredName,
    setSPreferredName,
    s_dob,
    setSDob,
    s_occupation,
    setSOccupation,
    s_mobile,
    setSMobile,
    s_landline,
    setSLandline,
    s_address1,
    setSAddress1,
    s_address2,
    setSAddress2,
    s_city,
    setSCity,
    s_country,
    setSCountry,
    s_postcode,
    setSPostcode,
    s_contactDescription,
    setSContactDescription,
    setAuditLogs,
    auditLogs,

    setIsChanged,
  } = useClientContext()

  const [show, setShow] = useState(false)
  const [history, setHistory] = useState([])

  const [loading, setLoading] = useState(false)

  // same details logic
  useEffect(() => {
    handleSameDetails()
  }, [sameDetails])

  const handleSameDetails = () => {
    if (sameDetails) {
      setSPrefix(p_prefix)
      setSForename(p_forename)
      setSSurname(p_surname)
      setSEmail(p_email)
      setSPreferredName(p_preferredName)
      setSDob(p_dob)
      setSOccupation(p_occupation)
      setSMobile(p_mobile)
      setSLandline(p_landline)
      setSAddress1(p_address1)
      setSAddress2(p_address2)
      setSCity(p_city)
      setSCountry(p_country)
      setSPostcode(p_postcode)
      setSContactDescription(p_contactDescription)
    }
    // else {
    //   setSPrefix("")
    //   setSForename("")
    //   setSSurname("")
    //   setSEmail("")
    //   setSPreferredName("")
    //   setSDob("")
    //   setSOccupation("")
    //   setSMobile("")
    //   setSLandline("")
    //   setSAddress1("")
    //   setSAddress2("")
    //   setSCity("")
    //   setSCountry("")
    //   setSPostcode("")
    //   setSContactDescription("")
    // }
  }

  // ========================

  // validations
  const validate = () => {
    let tempErrors = {}
    if (!p_prefix) tempErrors.p_prefix = "Prefix is required."
    if (!p_forename) tempErrors.p_forename = "Forename is required."
    if (!p_surname) tempErrors.p_surname = "Surname is required."
    if (!p_preferredName)
      tempErrors.p_preferredName = "Preferred Name is required."
    if (!p_dob) tempErrors.p_dob = "Date of Birth is required."
    if (!p_occupation) tempErrors.p_occupation = "Occupation is required."

    if (!p_mobile) tempErrors.p_mobile = "Contact 1 is required."
    // else if (p_mobile.length < 7 && p_mobile > 15) {
    //   tempErrors.p_mobile = "Invalid mobile number."
    // }

    if (!p_address1) tempErrors.p_address1 = "Address 1 is required."
    if (!p_city) tempErrors.p_city = "City is required."
    if (!p_country) tempErrors.p_country = "Country is required."

    if (!p_postcode) tempErrors.p_postcode = "Postcode is required."
    else if (p_postcode.length < 6 && p_postcode > 10) {
      tempErrors.p_postcode = "Invalid postcode number."
    }

    if (isPrimaryAbsence === "yes") {
      if (!s_prefix) tempErrors.s_prefix = "Prefix is required."
      if (!s_forename) tempErrors.s_forename = "Forename is required."
      if (!s_surname) tempErrors.s_surname = "Surname is required."
      if (!s_preferredName)
        tempErrors.s_preferredName = "Preferred Name is required."
      if (!s_dob) tempErrors.s_dob = "Dob is required."
      if (!s_occupation) tempErrors.s_occupation = "Occupation is required."

      if (!s_mobile) tempErrors.s_mobile = "Contact 1 is required."
      // else if (s_mobile.length < 7 && s_mobile > 15) {
      //   tempErrors.s_mobile = "Invalid mobile number."
      // }

      if (!s_address1) tempErrors.s_address1 = "Address 1 is required."
      if (!s_city) tempErrors.s_city = "City is required."
      if (!s_country) tempErrors.s_country = "Country is required."

      if (!s_postcode) tempErrors.s_postcode = "Postcode is required."
      else if (s_postcode.length < 6 && s_postcode > 10) {
        tempErrors.s_postcode = "Invalid postcode number."
      }
    }
    setErrors(tempErrors)
    return Object.keys(tempErrors).length === 0
  }

  const handleSubmit = async () => {
    if (validate() && !isReadOnly) {
      // if (true) {

      swal({
        title: "Are you sure?",
        text: `You want to save this details to ${clientName}.`,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async willDelete => {
        if (willDelete) {
          try {
            setLoading(true)
            const post_data = {
              primaryPrefixId: p_prefix,
              primaryForename: p_forename,
              primarySurname: p_surname,
              primaryEmail: p_email,
              primaryPreferredName: p_preferredName,
              primaryDOB: p_dob,
              primaryOccupation: p_occupation,
              primaryMobile: p_mobile,
              primaryLandline: p_landline,
              primaryAddressLine1: p_address1,
              primaryAddressLine2: p_address2,
              primaryCity: p_city?.value || p_city,
              primaryCountry: p_country,
              primaryPostcode: p_postcode,
              primaryContactDescription: p_contactDescription,

              haveSecondaryContact: isPrimaryAbsence,
              secondaryPrefixId: s_prefix,
              secondaryForename: s_forename,
              secondarySurname: s_surname,
              secondaryEmail: s_email,
              secondaryPreferredName: s_preferredName,
              secondaryDOB: s_dob,
              secondaryOccupation: s_occupation,
              secondaryMobile: s_mobile,
              secondaryLandline: s_landline,
              secondaryAddressLine1: s_address1,
              secondaryAddressLine2: s_address2,
              secondaryCity: s_city?.value || s_city,
              secondaryCountry: s_country,
              secondaryPostcode: s_postcode,
              secondaryContactDescription: s_contactDescription,
              sameAsPrimaryDetails: sameDetails,
            }

            const response = await axiosbaseurl.put(
              `/client/personal-details/${clientId || client_id}`,
              post_data
            )
            const { personalDetailLogs } = response.data
            if (response.data.success) {
              setClientId(response.data.data.id)
              setAuditLogs(prev => [
                ...prev,
                personalDetailLogs[personalDetailLogs.length - 1],
              ])
              setHistory(response.data.personalDetailLogs)
              setIsChanged(prev => ({ ...prev, 1: false }))
              swal("", "Details saved successfully", "success").then(() => {
                changeStep()
              })
            }
          } catch (error) {
            console.log(error)
            const msg =
              error.response.data.message ||
              error.message ||
              "Something went Wrong"

            swal(
              "",
              msg,
              msg.includes("No changes were made !") ? "warning" : "error"
            )
          } finally {
            setLoading(false)
          }
        }
      })
    } else window.scrollTo(0, 100)
  }

  return (
    <>
      <Card>
        <CardBody>
          <div className="row mb-2">
            <div className="d-flex justify-content-between">
              <h4 className="fw-bold mb-4">Primary Contact Details</h4>

              <div>
                <button
                  type="button"
                  className="btn btn-sm btn-light"
                  onClick={() => {
                    setHistory(auditLogs.filter(item => item.module === "CPD"))
                    setShow(true)
                  }}
                >
                  <i className="bx bx-history me-1"></i> Updated history
                </button>
              </div>
            </div>

            <div className="col-md-4 mb-3">
              <label>
                Prefix <span className="text-danger">*</span>
              </label>
              <select
                disabled={isReadOnly}
                value={p_prefix}
                onChange={e => setPPrefix(e.target.value)}
                className="form-select input-field"
              >
                <option value="">Select </option>
                {prefix_options
                  ?.slice()
                  .sort((a, b) => a.prefixName.localeCompare(b.prefixName))
                  .map(item => {
                    return (
                      <option key={item.id} value={item.id}>
                        {item.prefixName}
                      </option>
                    )
                  })}
              </select>
              <span className="error">{errors.p_prefix}</span>
            </div>

            <div className="col-md-4 mb-3">
              <label>
                Forename <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                placeholder="Enter Forename"
                disabled={isReadOnly}
                className="form-control input-field"
                value={p_forename}
                onChange={e => setPForename(e.target.value)}
              />
              <span className="error">{errors.p_forename}</span>
            </div>

            <div className="col-md-4 mb-3">
              <label>
                Surname <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                placeholder="Enter Surname"
                disabled={isReadOnly}
                className="form-control input-field"
                value={p_surname}
                onChange={e => setPSurname(e.target.value)}
              />
              <span className="error">{errors.p_surname}</span>
            </div>

            <div className="col-md-4 mb-3">
              <label>
                Preferred Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                placeholder="Enter Preferred Name"
                disabled={isReadOnly}
                className="form-control input-field"
                value={p_preferredName}
                onChange={e => setPPreferredName(e.target.value)}
              />
              <span className="error">{errors.p_preferredName}</span>
            </div>

            <div className="col-md-4 mb-3">
              <label>Email Address</label>
              <input
                type="text"
                placeholder="Enter Email Address"
                disabled={isReadOnly}
                className="form-control input-field"
                value={p_email}
                onChange={e => setPEmail(e.target.value)}
              />
            </div>

            <div className="col-md-4 mb-3">
              <label>
                Date of Birth <span className="text-danger">*</span>
              </label>
              <input
                type="date"
                disabled={isReadOnly}
                className="form-control input-field"
                value={p_dob}
                onChange={e => setPDob(e.target.value)}
                max={new Date().toISOString().split("T")[0]}
              />
              <span className="error">{errors.p_dob}</span>
            </div>

            <div className="col-md-4 mb-3">
              <label>
                Occupation <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                placeholder="Enter Occupation"
                disabled={isReadOnly}
                className="form-control input-field"
                value={p_occupation}
                onChange={e => setPOccupation(e.target.value)}
              />
              <span className="error">{errors.p_occupation}</span>
            </div>

            <div className="col-md-4 mb-3">
              <label>
                Contact Number 1 <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                placeholder="Enter Contact Number 1"
                disabled={isReadOnly}
                className="form-control input-field"
                value={p_mobile}
                onChange={e => setPMobile(e.target.value)}
                onKeyDown={validateContact}
              />
              <span className="error">{errors.p_mobile}</span>
            </div>

            <div className="col-md-4 mb-3">
              <label>Contact Number 2 </label>
              <input
                type="text"
                placeholder="Enter Contact Number 2"
                disabled={isReadOnly}
                className="form-control input-field"
                value={p_landline}
                onChange={e => setPLandline(e.target.value)}
                onKeyDown={validateContact}
              />
            </div>

            <div className="col-md-4 mb-3">
              <label>
                Address Line 1 <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                placeholder="Enter Address Line 1"
                disabled={isReadOnly}
                className="form-control input-field"
                value={p_address1}
                onChange={e => setPAddress1(e.target.value)}
              />
              <span className="error">{errors.p_address1}</span>
            </div>

            <div className="col-md-4 mb-3">
              <label>Address Line 2</label>
              <input
                type="text"
                placeholder="Enter Address Line 2"
                disabled={isReadOnly}
                className="form-control input-field"
                value={p_address2}
                onChange={e => setPAddress2(e.target.value)}
              />
            </div>

            <StateCity
              city={p_city}
              setCity={setPCity}
              state={p_country}
              setState={setPCountry}
              isReadOnly={isReadOnly}
              errors={{ city: errors.p_city, state: errors.p_country }}
            />

            <div className="col-md-4 mb-3">
              <label>
                Postcode <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                placeholder="Enter Postcode"
                disabled={isReadOnly}
                className="form-control input-field"
                value={p_postcode}
                onChange={e => setPPostcode(e.target.value)}
              />
              <span className="error">{errors.p_postcode}</span>
            </div>

            <div className="col-md-12 mb-3">
              <label>Additional Primary Contact Notes</label>
              <textarea
                type="text"
                placeholder="Enter Additional Primary Contact Notes"
                disabled={isReadOnly}
                className="form-control input-field"
                value={p_contactDescription}
                onChange={e => setPContactDescription(e.target.value)}
              />
              <span className="error">{errors.p_contactDescription}</span>
            </div>

            <div className="col-md-8 mb-3">
              <label>
                In absense of primary contact, can we reach out to a secondary
                contact?
              </label>

              <div className="d-flex align-items-center">
                <div>
                  <input
                    type="radio"
                    name="absence"
                    value={"yes"}
                    disabled={isReadOnly}
                    onChange={e => setisPrimaryAbsence(e.target.value)}
                    checked={isPrimaryAbsence === "yes"}
                  />{" "}
                  Yes
                </div>
                <div className="ms-3">
                  <input
                    type="radio"
                    name="absence"
                    value={"no"}
                    disabled={isReadOnly}
                    onChange={e => {
                      setisPrimaryAbsence(e.target.value)
                      // if (sameDetails)
                      //   setSameDetails(false)
                    }}
                    checked={isPrimaryAbsence === "no"}
                  />{" "}
                  No
                </div>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>

      {isPrimaryAbsence === "yes" && (
        <Card>
          <CardBody>
            <div className="row mb-2">
              <h4 className="fw-bold mb-3">Secondary Contact Details</h4>

              <div className="d-flex align-items-center mb-4">
                <div>Same as primary details </div>
                <div className="form-check form-switch form-switch-md ms-0 ps-3 mb-0 text-center">
                  <input
                    type="checkbox"
                    className="form-check-input fs-2 ms-0 me-0 "
                    style={{ left: 0 }}
                    disabled={isReadOnly}
                    checked={sameDetails}
                    onChange={e => {
                      setSameDetails(e.target.checked)
                      if (!e.target.checked) {
                        setSPrefix("")
                        setSForename("")
                        setSSurname("")
                        setSEmail("")
                        setSPreferredName("")
                        setSDob("")
                        setSOccupation("")
                        setSMobile("")
                        setSLandline("")
                        setSAddress1("")
                        setSAddress2("")
                        setSCity("")
                        setSCountry("")
                        setSPostcode("")
                        setSContactDescription("")
                      }
                    }}
                  />
                </div>
              </div>

              <div className="col-md-4 mb-3">
                <label>
                  Prefix <span className="text-danger">*</span>
                </label>
                <select
                  value={s_prefix}
                  onChange={e => setSPrefix(e.target.value)}
                  disabled={isReadOnly}
                  className="form-select input-field"
                >
                  <option value="">Select </option>
                  {prefix_options
                    ?.slice()
                    .sort((a, b) => a.prefixName.localeCompare(b.prefixName))
                    .map(item => {
                      return (
                        <option key={item.id} value={item.id}>
                          {item.prefixName}
                        </option>
                      )
                    })}
                </select>
                <span className="error">{errors.s_prefix}</span>
              </div>

              <div className="col-md-4 mb-3">
                <label>
                  Forename <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter Forename"
                  disabled={isReadOnly}
                  className="form-control input-field"
                  value={s_forename}
                  onChange={e => setSForename(e.target.value)}
                />
                <span className="error">{errors.s_forename}</span>
              </div>

              <div className="col-md-4 mb-3">
                <label>
                  Surname <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter Surname"
                  disabled={isReadOnly}
                  className="form-control input-field"
                  value={s_surname}
                  onChange={e => setSSurname(e.target.value)}
                />
                <span className="error">{errors.s_surname}</span>
              </div>

              <div className="col-md-4 mb-3">
                <label>
                  Preferred Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter Preferred Name"
                  disabled={isReadOnly}
                  className="form-control input-field"
                  value={s_preferredName}
                  onChange={e => setSPreferredName(e.target.value)}
                />
                <span className="error">{errors.s_preferredName}</span>
              </div>

              <div className="col-md-4 mb-3">
                <label>Email Address</label>
                <input
                  type="text"
                  placeholder="Enter Email Address"
                  disabled={isReadOnly}
                  className="form-control input-field"
                  value={s_email}
                  onChange={e => setSEmail(e.target.value)}
                />
              </div>

              <div className="col-md-4 mb-3">
                <label>
                  Date of Birth <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  className="form-control input-field"
                  disabled={isReadOnly}
                  value={s_dob}
                  onChange={e => setSDob(e.target.value)}
                  max={new Date().toISOString().split("T")[0]}
                />
                <span className="error">{errors.s_dob}</span>
              </div>

              <div className="col-md-4 mb-3">
                <label>
                  Occupation <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter Occupation"
                  disabled={isReadOnly}
                  className="form-control input-field"
                  value={s_occupation}
                  onChange={e => setSOccupation(e.target.value)}
                />
                <span className="error">{errors.s_occupation}</span>
              </div>

              <div className="col-md-4 mb-3">
                <label>
                  Contact Number 1 <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter Contact Number 1"
                  disabled={isReadOnly}
                  className="form-control input-field"
                  value={s_mobile}
                  onChange={e => setSMobile(e.target.value)}
                  onKeyDown={validateContact}
                />
                <span className="error">{errors.s_mobile}</span>
              </div>

              <div className="col-md-4 mb-3">
                <label>Contact Number 2</label>
                <input
                  type="text"
                  placeholder="Enter Contact Number 2"
                  className="form-control input-field"
                  value={s_landline}
                  onChange={e => setSLandline(e.target.value)}
                  disabled={isReadOnly}
                  onKeyDown={validateContact}
                />
              </div>

              <div className="col-md-4 mb-3">
                <label>
                  Address Line 1 <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter Address Line 1"
                  disabled={isReadOnly}
                  className="form-control input-field"
                  value={s_address1}
                  onChange={e => setSAddress1(e.target.value)}
                />
                <span className="error">{errors.s_address1}</span>
              </div>

              <div className="col-md-4 mb-3">
                <label>Address Line 2</label>
                <input
                  type="text"
                  placeholder="Enter Address Line 2"
                  disabled={isReadOnly}
                  className="form-control input-field"
                  value={s_address2}
                  onChange={e => setSAddress2(e.target.value)}
                />
              </div>

              <StateCity
                city={s_city}
                setCity={setSCity}
                state={s_country}
                setState={setSCountry}
                isReadOnly={isReadOnly}
                errors={{ city: errors.s_city, state: errors.s_country }}
              />

              <div className="col-md-4 mb-3">
                <label>
                  Postcode <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter Postcode"
                  disabled={isReadOnly}
                  className="form-control input-field"
                  value={s_postcode}
                  onChange={e => setSPostcode(e.target.value)}
                />
                <span className="error">{errors.s_postcode}</span>
              </div>
              <div className="col-md-12 mb-3">
                <label>Additional Secondary Contact Notes</label>
                <textarea
                  type="text"
                  placeholder="Enter Secondary Additional Contact Notes"
                  disabled={isReadOnly}
                  className="form-control input-field"
                  value={s_contactDescription}
                  onChange={e => setSContactDescription(e.target.value)}
                />
                <span className="error">{errors.p_contactDescription}</span>
              </div>
            </div>
          </CardBody>
        </Card>
      )}
      
      {!isReadOnly ? (
        <Card>
          <CardBody>
            <LoadingButton
              loading={loading}
              btnText="Save & Next"
              icon_2={<i className="fas fa-arrow-right ms-3"></i>}
              handler={handleSubmit}
            />
          </CardBody>
        </Card>
      ) : null}

      {/* logs Modal */}
      <Modal
        size="xl"
        isOpen={show}
        toggle={() => setShow(!show)}
        centered={true}
      >
        <div className="modal-content">
          <ModalBody className="px-3 ">
            <div className="d-flex justify-content-between">
              <h5>Updated History</h5>
              <button
                type="button"
                className="btn-close "
                onClick={() => setShow(!show)}
              ></button>
            </div>
            <div
              style={{
                maxHeight: "550px",
                overflow: "auto",
                scrollbarWidth: "thin",
              }}
            >
              <table className="table mt-3" style={{ verticalAlign: "middle" }}>
                <thead className="table-primary">
                  <tr>
                    <th>Sr. No</th>
                    <th>Date</th>
                    <th>User</th>
                    <th>Previous Data</th>
                    <th>Updated Data</th>
                  </tr>
                </thead>
                <tbody>
                  {history.reverse().map((item, i) => (
                    <tr key={item.id}>
                      <td>{i + 1}</td>
                      <td>
                        {moment(item.createdAt).format("DD-MM-YYYY | hh:mm  A")}
                      </td>
                      <td>{item.updatedBy}</td>
                      <td>
                        <table border="1" className="table">
                          <tbody className="table-light">
                            {Object.entries(JSON.parse(item?.previousData)).map(
                              ([key, value]) => (
                                <tr key={key}>
                                  <th className="py-2 w-50">
                                    {key
                                      .replace(/([A-Z])/g, "$1")
                                      .replace(/^./, str => str.toUpperCase())}
                                  </th>
                                  <td className="py-2">{value}</td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </td>
                      <td>
                        <table border="1" className="table">
                          <tbody className="table-light">
                            {Object.entries(JSON.parse(item?.updatedData)).map(
                              ([key, value]) => (
                                <tr key={key}>
                                  <th className="py-2 w-50">
                                    {key
                                      .replace(/([A-Z])/g, "$1")
                                      .replace(/^./, str => str.toUpperCase())}
                                  </th>
                                  <td className="py-2">{value}</td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </ModalBody>
        </div>
      </Modal>
    </>
  )
}

function StateCity({ state, setState, city, setCity, errors, isReadOnly }) {
  // for states & city
  const { states, cities, handleStateChange } = useLocationData()

  useEffect(() => {
    if (state) handleStateChange(state)
  }, [state])

  return (
    <>
      <div className="col-md-4 mb-3">
        <label>
          Country <span className="text-danger">*</span>
        </label>
        <select
          onChange={e => {
            setState(e.target.value)
            setCity("")
          }}
          value={state}
          disabled={isReadOnly}
          className="form-select input-field"
        >
          <option value="">Select Country</option>
          {states.map(state => {
            return (
              <option key={state.isoCode} value={state.isoCode}>
                {state.name}
              </option>
            )
          })}
          <option value="Non-UK">Non-UK</option>
        </select>
        <span className="error">{errors.state}</span>
      </div>

      <div className="col-md-4 mb-3">
        <label>
          City <span className="text-danger">*</span>
        </label>

        {state == "Non-UK" ? (
          <input
            type="text"
            placeholder="Enter City"
            value={city}
            disabled={isReadOnly}
            onChange={e => setCity(e.target.value)}
            className="form-control input-field"
          />
        ) : (
          <Select
            value={city}
            onChange={e => setCity(e)}
            options={cities}
            styles={customStyles}
            placeholder="Select City"
            isDisabled={isReadOnly}
          />
        )}

        <span className="error">{errors.city}</span>
      </div>
    </>
  )
}

export default Personal
